module.exports = __webpack_public_path__ + "static/scale-model-of-el-museo-latino-in-omaha-nebraska-fa0184bf2ed25a93ac605d4d61538d15.png";